import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';

export class ActivityTypeResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null;

  @ApiProperty({
    type: Object,
    description: 'Schéma JSON définissant la structure du contenu',
  })
  jsonSchema!: Record<string, any>;

  @ApiProperty({
    type: Object,
    description: 'Configuration par défaut associée au type',
  })
  defaultConfig!: Record<string, any>;

  @ApiProperty({ type: Boolean })
  supportsAutoGrading!: boolean;

  @ApiProperty({ type: Boolean })
  supportsRetries!: boolean;

  @ApiPropertyOptional({ type: Number, nullable: true })
  maxAttempts!: number | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  icon!: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  color!: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  category!: string | null;

  @ApiProperty({ type: Boolean })
  isActive!: boolean;

  @ApiProperty({ type: Boolean })
  isExercice!: boolean;

  @ApiProperty({ type: Number, description: 'Nombre de templates utilisant ce type' })
  templatesCount!: number;

  @ApiProperty({ type: Number, description: "Nombre d'activités utilisant ce type" })
  activitiesCount!: number;
}
